module.exports = "/_next/static/images/3028c203a0e4b4392782835942fd49a0-bars-md.jpg.webp";